import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import * as d3 from 'd3';
import { BubbleChartConfiguration } from "./bubble-chart.configuration";
import { HierarchyNode } from "d3-hierarchy";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'kla-bubble-chart',
  templateUrl: './bubble-chart.component.html',
  styleUrls: ['./bubble-chart.component.scss'],
  standalone: true,
  imports: [ CommonModule ]
})
export class BubbleChartComponent implements OnInit {


  @ViewChild('bubbleChart', {static: true}) private chartContainer: ElementRef;

  @Input()
  public config: any;

  @Input('width')
  set setWidth(width: number) {
    this.config.width = width;
    this.ngOnInit();
  }

  public avatarCount: number = 0;

  public testIndex: number = 0;

  constructor() { }

  ngOnInit() {
    let that = this;

    let view = this.createViewPort(this.config.width, this.config.height);

    var defs = view.append('svg:defs');


    let stratify = d3.stratify()(this.config.data);


    var bubble = d3.pack()
      .size([this.config.width - 100, this.config.height - 100])
      .padding(30);


    let hierarchy = d3.hierarchy(stratify).sum(function (d) {
      return d.data["size"];
    });

    let nodes = hierarchy.descendants();
    var bubbleData = bubble(hierarchy);


    var vSlices = view.selectAll('circle').data(nodes).enter()

    vSlices.append('circle')
      .attr("id", function (d, i) {
        return "circle-" + i;
      })
      .attr('cx', function (d) { return d["x"]; })
      .attr('cy', function (d) { return d["y"]; })
      .attr('r', function (d) { return d["r"]; })
      .style("fill", function (d, i) {
        if (i > 0) {
          return that.createImageDefs(defs, d.data.data["image"], d["r"], d["x"], d["y"]);
        } else {
          return "transparent";
        }
      })
      .style("outline", "none" )
      .on("mouseover", function(d,i){ that.showCircleText(i) })
      .on("mouseout", function(d,i){ that.hideCircleText(i) })


    vSlices.append("line")
      .style("stroke", function (d) {
        return d.data.data["color"]
      })
      .style("opacity", 0)
      .attr("id", function (d, i) {
        return "labelLine-" + i;
      })
      .attr("x1", function (d, i) {
        return that.createPointCoordinates(i, 'x', d['x'], d['r'], -15)
      })
      .attr("y1", function (d, i) {
        return that.createPointCoordinates(i, 'y', d['y'], d['r'], 15)
      })
      .attr("x2", function (d, i) {
        return that.createPointCoordinates(i, 'x', d['x'], d['r'], 15)
      })
      .attr("y2", function (d, i) {
        return that.createPointCoordinates(i, 'y', d['y'], d['r'], -15)
      })
      .attr("stroke-width", 2.5);


    vSlices.append("text")
      .attr("id", function (d, i) {
        return "label-" + i;
      })
      .attr("class", function (d, i) {
        let index = (i > 0) ? d.data.data["size"] : "";
        return "bubbleLabel-" + index;
      })
      .attr("text-anchor", function (d, i) {
        return (i == 1) ? "end" : "start";
      })
      .attr("x", function (d, i) {
        let spacing = (i == 1) ? 20 : 30;
        return that.createPointCoordinates(i, 'x', d['x'], d['r'], spacing)
      })
      .attr("y", function (d, i) {
        let spacing = (i == 1) ? 25 : 35;
        return that.createPointCoordinates(i, 'y', d['y'], d['r'], 35)
      })
      .style("opacity", 0)
      .style("pointer-events", "none")
      .text(function (d) {
        return d.data.data["label"]
      })
      .attr("font-family", "sans-serif")
      .attr("font-size", "10px")
      .attr("fill", "gray")
      .call(that.wrapLabel, 100, 10)
      .call(that.getBB); 

      //add rect for text background
      vSlices.insert("rect","text")
        .style("opacity", 0)
            .attr("id", function (d, i) {
            return "labelRect-" + i;
        })
        .attr("x",  function (d, i) {
          if(i>0){
            let spacing = (i == 1) ? 20 : 30;
            if(i==1)
              return that.createPointCoordinates(i, 'x', d['x'], d['r'], spacing) - d['bbox'].width -5

            return that.createPointCoordinates(i, 'x', d['x'], d['r'], spacing) -5
          }
          return 0
        })
        .attr("y", function (d, i) {
          if(i>0){
            let spacing = (i == 1) ? 25 : 55 ;
            let rightVerticall = (i > 1 && i < 5)?  -10 : 0;
            return that.createPointCoordinates(i, 'y', d['y'], d['r'], spacing)  + rightVerticall
          }
          return 0
        })
        .attr("width", function(d){return d['bbox'].width + 10})
        .attr("height", function(d){return d['bbox'].height})
        .style("pointer-events", "none")
        .style("fill", "white");
    
  }
  
  createViewPort(width: number, height: number) {

    d3.select(this.chartContainer.nativeElement).selectAll(".bubble-graph").remove();
    let translateX, viewBox: number
    if (width >= 600) {
      translateX = -width / 6;
      viewBox = 408;
    } else if (width >= 550) {
      translateX = -20;
      viewBox = 458;
    }
    else if (width >= 500) {
      translateX = -22;
      viewBox = 508;
    }

    return d3.select(this.chartContainer.nativeElement)
      .append('svg')
      .attr('class', 'pie bubble-graph')
      .attr('width', width)
      .attr('height', height)
      .attr("viewBox", "0 0 " + viewBox + " " + viewBox)
      .append('g')
      .attr("transform", "translate(" + translateX + "," + 30 + ")")
  }

  showCircleText(index){
    d3.select("#label-" + index).style("opacity", 1);
    d3.select("#labelLine-" + index).style("opacity", 1);
    d3.select("#labelRect-" + index).style("opacity", 1);    
  }

  hideCircleText(index){
    d3.select("#label-" + index).style("opacity", 0);
    d3.select("#labelLine-" + index).style("opacity", 0);
    d3.select("#labelRect-" + index).style("opacity", 0); 
  }

  getBB(selection) {
    selection.each(function(d){d.bbox = this.getBBox();})
  }

  wrapLabel(text, width, lineHeight) {
    text.each(function (t, index) {
      if (index > 0) {
        var text = d3.select(this),
          words = (index > 4) ? text.text().split(/\s+/) : text.text().split(/\s+/).reverse(),
          word,
          line = [],
          lineNumber = 0,
          x = text.attr("x"),
          y = text.attr("y"),
          dy = parseFloat(text.attr("dy")),
          tspan = text.text(null).append("tspan");

        while (word = words.pop()) {
          line.push(word);
          tspan.text(line.join(" "));
          if (tspan.node()["getComputedTextLength"]() > width) {
            line.pop();
            tspan.text(line.join(" "));
            line = [word];
            tspan = text.append("tspan").attr("x", x).attr("dy", (index > 4) ? lineHeight - lineHeight * words.length : lineHeight + "px").text(word);
          }
        }

        let value = text.attr("class").split('-')[1];
        tspan = text.append("tspan").attr("x", x).attr("dy", (index > 4) ? lineHeight * 2 + 3 : lineHeight + 3 + "px").text(value).attr("font-family", "sans-serif")
          .attr("font-size", "12px").attr("font-weight", "bold").attr("fill", "black");
      }
    });
  }


  // images for circles 
  createImageDefs(defs, imageUrl, width, x, y) {
    this.avatarCount++;

    defs.append("svg:pattern")
      .attr("id", "avatar" + this.avatarCount)
      .attr("width", "100%")
      .attr("height", "100%")
      .attr("patternContentUnits", "objectBoundingBox")
      .append("svg:image")
      .attr("xlink:href", imageUrl)
      .attr("width", 1)
      .attr("height", 1)
      .attr("preserveAspectRatio", "none")

    return "url(" + window.location.href + "#avatar" + this.avatarCount + ")"
  }

  createPointCoordinates(index: number, axis: string, axisValue: number, radius: number, spacing: number) {
    if (axis == 'x') {
      if (index == 1 || index >= 5) {
        return axisValue;
      }
      else if (index > 1 && index < 5) {
        return axisValue + radius + spacing
      }
    }
    else if (axis == 'y') {
      if (index == 1) {
        return axisValue + radius + spacing
      }
      else if (index > 1 && index < 5) {
        return axisValue
      }
      else if (index >= 5) {
        return axisValue - radius - spacing
      }
    }
  }

}
